export enum IdentificationProvider {
  TRUST_ID = 'trust-id',
  SWISS_ID = 'swiss-id',
  HIN = 'hin',
  GENEVE_ID = 'geneve-id',
  VAUD_ID = 'vaud-id',
}
